import { Component, OnInit, Input, Output, EventEmitter, TemplateRef, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { RoutePages } from '../../../enum/route-pages';
import { LayoutService } from 'codex-lib';
import { SortOrder } from 'src/app/enum/sort-order';
import { EnvelopeFilter } from '../../model/envelope-filter';
import { EnvelopeSortOption } from '../../model/envelope-sort-option';

@Component({
  selector: 'app-envelope-list',
  templateUrl: './envelope-list.component.html',
  styleUrls: ['./envelope-list.component.scss']
})
export class EnvelopeListComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('toolbarCodex') toolbar: TemplateRef<any>;

  @Output() onChangeType = new EventEmitter();
  @Output() checkAllClick = new EventEmitter();
  @Output() searchValueChange = new EventEmitter();
  @Output() sortOrderChange = new EventEmitter();
  @Output() sortChange = new EventEmitter<EnvelopeSortOption>();
  @Output() filterChange = new EventEmitter();
  @Output() filterClear = new EventEmitter();
  @Output() filterButtonClick = new EventEmitter<void>();

  @Input() searchValue: string;
  @Input() sortOptions: EnvelopeSortOption[] = [];
  @Input() selectedSortOption: EnvelopeSortOption;
  @Input() sortOnboardingReady = true;

  constructor(private router: Router,
    public layoutService: LayoutService) {
    this.layoutService.headerProp.next({ title: 'menu.sent' });
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.layoutService.toolbarTemplateRef.next(this.toolbar);
  }

  ngOnDestroy(): void {

  }

  onChangeToGrid() {
    this.onChangeType.emit(false);
  }

  onChangeToList() {
    this.onChangeType.emit(true);
  }

  onCheckAllClick(checked: boolean) {
    this.checkAllClick.emit(checked);
  }

  onSearchValueChange(value: string) {
    this.searchValueChange.emit(value);
  }

  onSortOrderChange(sortOrder: SortOrder) {
    this.sortOrderChange.emit(sortOrder);
  }

  onSortChange(sortOption: EnvelopeSortOption) {
    this.sortChange.emit(sortOption);
  }

  onFilterChange(filter: EnvelopeFilter) {
    this.filterChange.emit(filter);
  }

  onFilterClear(filter: EnvelopeFilter) {
    this.filterClear.emit(filter);
  }

  onFilterButtonClick() {
    this.filterButtonClick.emit();
  }
}
